import { commonLinkStyles } from "@iewcasia/Utilities/styleguide/Links";
import { colorStrings } from "@iewcasia/Utilities/variables";
import { StyledButton } from "@insite/mobius/Clickable";
import { DataTablePresentationProps } from "@insite/mobius/DataTable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

export const dataTable: RecursivePartial<{
    defaultProps?: DataTablePresentationProps;
}> = {
    defaultProps: {
        sortIconProps: {
            size: 22,
        },
        mergeCss: true,
        css: css`
            text-align: left;
            border-spacing: 0;
            border-collapse: collapse;
            overflow-x: auto;
            white-space: nowrap;
            display: table;
            line-height: normal;

            /* width */
            ::-webkit-scrollbar {
                width: 5px;
            }

            /* Track */
            ::-webkit-scrollbar-track {
                background: #eff1f2;
            }

            /* Handle */
            ::-webkit-scrollbar-thumb {
                background: #015583;
            }

            /* Handle on hover */
            ::-webkit-scrollbar-thumb:hover {
                background: #015583;
            }

            thead,
            thead th,
            thead tr th {
                padding: 8px;
                background-color: ${getColor(colorStrings.commonGlobalGray01)};
                color: ${getColor(colorStrings.commonGlobalWhite)};
                font-size: 14px;
                font-weight: 700;
                border: 1px solid ${getColor(colorStrings.commonGlobalGray05)};

                ${TypographyStyle} {
                    font-size: 14px;
                    font-weight: 700;
                }
            }

            /* stylelint-disable-next-line */
            thead th ${StyledButton}, thead th ${IconWrapper} {
                color: ${getColor(colorStrings.commonGlobalWhite)};
                font-size: 14px;
                font-weight: 700;
            }

            tr:not(.product-accordion-content) td,
            tbody tr:not(.product-accordion-content),
            tbody tr:not(.product-accordion-content) td {
                padding: 8px;
                color: ${getColor(colorStrings.textMain)};
                font-size: 14px;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                border: 2px solid ${getColor(colorStrings.commonGlobalGray04)};

                ${TypographyStyle} {
                    font-size: 14px;
                }

                a {
                    ${commonLinkStyles}
                }
            }

            tr:nth-child(even) {
                background: ${getColor(colorStrings.commonGlobalWhite)};
            }

            tr:nth-child(odd) {
                background: ${getColor(colorStrings.commonGlobalGray05)};
            }
        `,
    },
};
